/** The store shell (mobilekit, Capacitor) — what the web can see of it. */
export type CapWindow = Window & {
  Capacitor?: {
    isNativePlatform?: () => boolean;
    Plugins?: {
      Browser?: { open: (o: { url: string }) => Promise<void> };
      AppLauncher?: { openUrl: (o: { url: string }) => Promise<{ completed: boolean }> };
    };
  };
};

export function inNativeShell(): boolean {
  return typeof window !== "undefined" && !!(window as CapWindow).Capacitor?.isNativePlatform?.();
}

/** Open a URL in the phone's REAL browser, as its own app — never a Custom Tab
 *  drawn over us when the launcher exists, never an intent:// the WebView would
 *  try to load as a page (both tried and rejected on Serviceitz, 18/19 Sep 2026). */
export function openInSystemBrowser(url: string): void {
  const plugins = (window as CapWindow).Capacitor?.Plugins;
  const launcher = plugins?.AppLauncher?.openUrl;
  if (launcher) { launcher({ url }).catch(() => plugins?.Browser?.open({ url })); return; }
  if (plugins?.Browser) { plugins.Browser.open({ url }).catch(() => window.open(url, "_blank")); return; }
  window.open(url, "_blank");
}
